import tinycolor from 'tinycolor2';

var getDarkerColor = function getDarkerColor(color) {
  var lightenValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.1;

  var _tinycolor$toHsl = tinycolor(color).toHsl(),
      h = _tinycolor$toHsl.h,
      s = _tinycolor$toHsl.s,
      l = _tinycolor$toHsl.l;

  return tinycolor("hsl(".concat(h, ", ").concat(s, ", ").concat(l - lightenValue, ")")).toHexString();
};

export default getDarkerColor;